export const buttonStyles = `
:host {
  display: inline-block;
  font-family: inherit;
}
.zid-login-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  height: 3rem;
  padding: 0 3rem;
  border: 0;
  border-radius: 9999px;
  background: linear-gradient(to right, #2563eb, #312e81);
  color: #ffffff;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s cubic-bezier(0, 0, 0.2, 1);
}
.zid-login-button:hover:not(:disabled) {
  background: linear-gradient(to right, #1d4ed8, #1e1b4b);
}
.zid-login-button:disabled {
  opacity: 0.7;
  cursor: default;
}
.zid-login-button--minimal {
  width: 3rem;
  height: 3rem;
  padding: 0;
  border-radius: 50%;
}
.zid-login-button--minimal .zid-login-button__icon {
  width: 1.375rem;
  height: 1.375rem;
}
.zid-login-button__icon {
  flex: none;
  width: 1.125rem;
  height: 1.125rem;
}
.zid-login-button__icon svg {
  display: block;
  width: 100%;
  height: 100%;
}
.zid-info-box {
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  margin-top: 0.75rem;
  padding: 0.875rem 1rem;
  border-radius: 12px;
  border: 1px solid #e3e4e5;
  background: #f3f4f6;
  font-family: inherit;
}
.zid-info-box__icon {
  flex: none;
  width: 1.125rem;
  height: 1.125rem;
  margin-top: 0.125rem;
  color: #2563eb;
}
.zid-info-box__icon svg {
  display: block;
  width: 100%;
  height: 100%;
}
.zid-info-box__title {
  margin: 0 0 0.25rem;
  font-size: 0.75rem;
  font-weight: 650;
  color: #1e3a5f;
}
.zid-info-box__description {
  margin: 0;
  font-size: 0.75rem;
  line-height: 1.45;
  color: rgba(30, 58, 95, 0.72);
}
`
    